/**
 * Обрезаем количество цифр c начала строки номера карты
 * @param cardNumber - номер карты
 * @param quantity - количество символов
 */
export const cropNumberOfCard = (cardNumber: string, quantity: number) =>
  cardNumber.slice(-quantity)
